import { render } from "./OrderMapper.vue?vue&type=template&id=45bde362&scoped=true"
import script from "./OrderMapper.vue?vue&type=script&lang=js"
export * from "./OrderMapper.vue?vue&type=script&lang=js"

import "./OrderMapper.vue?vue&type=style&index=0&id=45bde362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bde362"]])

export default __exports__